import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalState } from "../modal/modal";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export const initialState = {
  name: "",
} as ModalState;

export const toastSlice = createSlice({
  name: "toastSlice",
  reducers: {
    showToast: (state, action: PayloadAction<ModalState>) => {
      state.name = action.payload.name;
    },
    hideToast: (state) => {
      state.name = "";
    },
  },
  initialState,
});

export const { showToast, hideToast } = toastSlice.actions;

export default toastSlice.reducer;

export const useToast = () => {
  const { name } = useAppSelector((state) => state.toast);
  const dispatch = useAppDispatch();

  const dispatchShowToast = useCallback(
    (data: ModalState) => {
      dispatch(showToast(data));
    },
    [dispatch],
  );

  const dispatchHideToast = useCallback(() => {
    dispatch(hideToast());
  }, [dispatch]);

  return {
    dispatchShowToast,
    dispatchHideToast,
    name,
  };
};
